const localStorageKeys = {
  viprToken: 'vipr-token',
  viprRefreshToken: 'vipr-refresh-token',
  viprWSToken: 'vipr-ws-token',
  permissions: 'perm',
};

export default localStorageKeys;
